import { ComparatorEnum } from '../../../models/interface/comparator.enum';
import { PermissionHistoricalOption } from '../keys/permissionHistorical';
import { PermissionOption } from '../models/permissionOption.interface';

export const PermissionHistorical: PermissionOption[] = [
  {
    code: 'P439',
    option: PermissionHistoricalOption.DASHBOARD_HISTORICAL_COMMON_LOGIN,
    permissions: ['dashboards-historico.common.login'],
    comparator: ComparatorEnum.CONTAINS,
  }
];
